import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { LightbulbIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import routes from '@/Router/routes.constants'

import * as Styles from './styles'

const SizingWidgetBanner = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Styles.Container>
      <Styles.IconContainer>
        <LightbulbIcon size={32} weight="regular" />
      </Styles.IconContainer>
      <Styles.TextContainer>
        <Styles.StyledText type="bodyMRegular" color={theme.colors.outline.default}>
          <Trans i18nKey="u_metrics_products_sizing_widget_banner_title">
            <strong>Reduce las devoluciones por talla sin esfuerzo:</strong> Haz que nuestro widget de tallas alerte
            automáticamente a los compradores cuando los productos tallen grande o pequeño.
          </Trans>
        </Styles.StyledText>
      </Styles.TextContainer>
      <Styles.StyledButton
        size="s"
        variant="outlined"
        onClick={() => navigate(routes.configurationPage.extras.sizingWidget)}
      >
        {t('Configuración widget de tallas')}
      </Styles.StyledButton>
    </Styles.Container>
  )
}

export default SizingWidgetBanner
